import React from 'react';
import { Form } from 'react-bootstrap';
import { Fieldset, FormSelect, FormNumber } from '~/components/FormControl';
import { COMPARED_OPTIONS } from '~/config/constants';
import { formLabel } from '~/utils/helpers';

function DiceAndPointCompareCheck() {
    return (
        <Fieldset className={'px-2'}>
            <Fieldset.Legend>{formLabel('DiceAndPointCompareCheck')}</Fieldset.Legend>
            <Form.Row>
                <FormSelect
                    name="dvComparedOption"
                    options={COMPARED_OPTIONS || []}
                    sm={6}
                />
                <FormNumber
                    name="dvComparedValue"
                    min={0}
                    max={12}
                    sm={6}
                />
            </Form.Row>
            <Form.Row className="mt-3">
                <FormSelect
                    name="pointComparedOption"
                    options={COMPARED_OPTIONS || []}
                    sm={6}
                />
                <FormNumber
                    name="pointComparedValue"
                    min={0}
                    max={12}
                    sm={6}
                />
            </Form.Row>
        </Fieldset>
    );
}

export default DiceAndPointCompareCheck;
